import React, { Component } from 'react'
import { Input, Menu } from 'antd'
import { createSpec, getGroups, serviceHour } from './scatter-graph-spec'
import { connect } from 'react-redux'
import { getKpiSpec } from '../selectors'
import { fromNullable } from 'data.maybe'
import { withRouter } from 'react-router'
const specToLink = props => (
  <Menu.Item style={{ margin: '0px' }} exact key={`/scatter/${props.group}/${props.id}`}>
    {props.label}
  </Menu.Item>

  // <MenuItem
  //   key={`${props.id}-${props.group}`}
  //   {...props}
  //   prefix={`/scatter/${props.group}`}
  //   display={props.label}
  // />
)

class ScatterMenu extends Component {
  filterChanged = e => this.setState({ filterText: e.target.value })
  setSelectedKeys = selectedKeys => this.setState({ selectedKeys })
  render() {
    const { filterText, selectedKeys } = this.state || {}
    const { style, kpiSpec } = this.props
    const menus = getGroups(kpiSpec)

    const matchFilter = str =>
      fromNullable(filterText)
        .map(t => t.toLowerCase())
        .map(t => str.toLowerCase().includes(t))
        .getOrElse(true)

    const menuSelected = ({ key }) => {
      this.setSelectedKeys(key)
      //
      const { history } = this.props
      const location = { pathname: `${key}` }
      history.push(location)
    }

    return (
      <Menu
        selectedKeys={[selectedKeys]}
        // onSelect={({ key }) => this.setSelectedKeys(key)}
        onClick={menuSelected}
        style={{ ...style, height: '100%', width: '30%' }}
        theme="dark"
        mode="inline"
      >
        <Menu.Item>
          <Input
            icon="filter"
            placeholder="Filter..."
            value={filterText}
            onChange={this.filterChanged}
          />
        </Menu.Item>
        {/* <Menu.Item>
          <Menu.Header>Commercial Availability</Menu.Header>
          <Menu.Menu>
            {caGraphSpecs
              .filter(spec => matchFilter(spec.id) || matchFilter(spec.label))
              .map(specToLink)}
          </Menu.Menu>
        </Menu.Item> */}
        {menus
          .filter(v => v)
          .map(group => (
            <Menu.SubMenu key={`${group.id}-menu-item`} title={group.display}>
              {group.metrics
                .map(createSpec(group.id)(serviceHour))
                .filter(spec => matchFilter(spec.id) || matchFilter(spec.label))
                .map(specToLink)}
            </Menu.SubMenu>
          ))}
      </Menu>
    )
  }
}

const mapStateToProps = state => ({
  kpiSpec: getKpiSpec(state),
})

export default withRouter(connect(mapStateToProps)(ScatterMenu))
